// src/constants/columns/transactionColumns.js

export const transactionColumns = [
  { field: "customer", headerName: "Customer", flex: 1, minWidth: 150 },
  { field: "accountNumber", headerName: "Account No", flex: 1, minWidth: 140 },
  {
    field: "type",
    headerName: "Type",
    flex: 0.8,
    minWidth: 120,
    renderCell: (params) => (
      <span
        style={{
          color: params.value === "credit" ? "green" : "red",
          fontWeight: 600,
        }}
      >
        {params.value}
      </span>
    ),
  },
  { field: "amount", headerName: "Amount", flex: 1, minWidth: 130 },
  { field: "balance", headerName: "Balance", flex: 1, minWidth: 130 },
  { field: "doneBy", headerName: "Done By", flex: 1.2, minWidth: 160 },
  {
    field: "date",
    headerName: "Date & Time",
    flex: 1.5,
    minWidth: 180,
    renderCell: (params) =>
      new Date(params.value).toLocaleString(),
  },
];
